import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericService } from '../../../../core/services/generic.service';
import { FlightSearchRequest } from '../../models/flight-search-request';
import { FlightSearchResponse } from '../../models/flight-search-response';
import { PayRequest } from '../../models/pay-request';
import { UpsellingRequest } from '../../models/upselling-request';

@Injectable({ providedIn: 'root' })
export class FlightApi {
  constructor(private generic: GenericService) {}

  searchAirports(keyword: string): Observable<any> {
    return this.generic.GetUtil<any>(`airports/search?keyword=${keyword}`);
  }

  searchAirlines(keyWord: string): Observable<any> {
    return this.generic.GetUtil<any>(`airlines/search?keyword=${keyWord}`);
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////

  searchFlights(body: FlightSearchRequest): Observable<FlightSearchResponse> {
    return this.generic.post<FlightSearchResponse>('flights/v2/search', body);
  }

  searchFlightsMultiCity(
    body: FlightSearchRequest
  ): Observable<FlightSearchResponse> {
    return this.generic.post<FlightSearchResponse>(
      'flights/v2/search/multi-city',
      body
    );
  }

  researchFlights(searchId: string, params?: HttpParams) {
    return this.generic.postFlightWithParams<any>(
      `flights/v2/research`,
      { searchId },
      params
    );
  }

  researchFlightV2WithCalender(searchId: string): Observable<any> {
    return this.generic.post<any>(`flights/v2/research/calendar`, searchId);
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////

  getFlightsupselling(body: UpsellingRequest): Observable<any> {
    return this.generic.post<any>('flights/upselling', body);
  }

  confirmPrice(
    body: UpsellingRequest,
    bags: boolean = true,
    meals: boolean = true
  ): Observable<any> {
    return this.generic.post<any>(
      `flights/price?bags=${bags}&meals=${meals}`,
      body
    );
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////

  getSeatMap(request: UpsellingRequest): Observable<any> {
    return this.generic.post<any>('flights/seatmaps', request);
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////

  pay(request: PayRequest, doIssue: boolean = true): Observable<any> {
    return this.generic.post<any>(
      `flights/reservations?issue=${doIssue}`,
      request
    );
  }
}
